import styled from "styled-components";

export const Root = styled.div`
  display: grid;
  grid-template-columns: 150px 1fr;
  column-gap: 24px;
  padding-bottom: 40px;
  border-bottom: 1px solid #dbdfea;

  @media (max-width: 1023px) {
    grid-template-columns: 100px 1fr;
    column-gap: 16px;
  }
`;

export const Image = styled.img`
  width: 150px;
  height: 187px;
  object-fit: cover;
  border-radius: 2px;

  @media (max-width: 1023px) {
    width: 100px;
    height: 125px;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BrandName = styled.a`
  color: #e1000f;
  font-weight: 700;
  line-height: 1.2;
  text-transform: uppercase;
  text-decoration: none;
  margin-bottom: 8px;

  @media (max-width: 1023px) {
    font-size: 10px;
  }

  @media (min-width: 1024px) {
    font-size: 12px;
  }

  &:hover {
    color: #cb000e;
    text-decoration: underline;
  }
`;

export const ProductName = styled.div`
  font-weight: 600;
  line-height: 1.4;
  margin-bottom: 12px;

  @media (max-width: 1023px) {
    font-size: 14px;
  }

  @media (min-width: 1024px) {
    font-size: 16px;
  }
`;

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
`;

export const Tag = styled.span`
  display: inline-block;
  padding: 4px 12px;
  color: #5f6368;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.4;
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  text-transform: capitalize;
`;

export const QtyPts = styled.span`
  font-weight: 500;
  line-height: 1.6;

  @media (max-width: 1023px) {
    font-size: 11px;
  }

  @media (min-width: 1024px) {
    font-size: 14px;
  }
`;

export const PriceContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;

  @media (max-width: 1023px) {
    flex-direction: column;
    gap: 8px;
  }
`;

export const Subtotal = styled.div`
  text-align: right;

  @media (max-width: 1023px) {
    text-align: left;
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: auto;

  @media (max-width: 1023px) {
    justify-content: flex-start;
    gap: 16px;
  }
`;

export const RemoveButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  font-size: 20px;
  color: #8f95a5;
  transition: color 0.2s;

  &:hover {
    color: #e1000f;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const InputButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  font-size: 18px;
  font-weight: 600;
  color: #000;
  background-color: #fff;
  border: solid 1px #dbdfea;
  border-radius: 2px;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    border-color: #000;
  }

  &:disabled {
    color: #dbdfea;
    cursor: not-allowed;
  }
`;

export const Input = styled.input`
  width: 50px;
  height: 32px;
  margin: 0 8px;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  border: solid 1px #dbdfea;
  border-radius: 2px;
  outline: none;

  &:focus {
    border-color: #000;
  }
`;
